<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String | Number,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        class="border-gray-300 focus:border-logix-green focus:ring focus:ring-logix-green focus:ring-opacity-50 rounded-md shadow-sm disabled:bg-slate-200"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
</template>
